import { Injectable } from '@angular/core'
import { ViewSOAGateWay } from '../gateways/view-soa-gateways'
import { Observable } from 'rxjs'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { BeneficiarySoaDetail } from '../models/view-soa-model'
import { SearchInsertModel } from '../models/search-soa-model'
import { ExportSOAModel } from '../models/export-soa-model'

@Injectable()
export class NetworkViewSOAGateway extends ViewSOAGateWay {
    // TODO once methos in controller are defined , please call from here in order to return data from backend
    constructor(private http: HttpClient) {
        super()
    }

    searchBSOAData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]> {
        return this.http.post<BeneficiarySoaDetail[]>('../api/loadSOAforAgent', JSON.stringify(searchsoadetail))
    }

    searchPWBSOAData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]> {
        return this.http.post<BeneficiarySoaDetail[]>('../api/loadPWSOAforAgent', JSON.stringify(searchsoadetail))
    }

    loadBSOAData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]> {
        console.log('loadsoadata orgID' + searchsoadetail.OrgID)
        return this.http.post<BeneficiarySoaDetail[]>('../api/loadSOAforAgent', JSON.stringify(searchsoadetail))
    }

    loadPWBSOAData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]> {
        console.log('loadpwsoadata orgID' + searchsoadetail.OrgID)
        return this.http.post<BeneficiarySoaDetail[]>('../api/loadPWSOAforAgent', JSON.stringify(searchsoadetail))
    }

    loadBSOADataSync(searchsoadetail: SearchInsertModel): BeneficiarySoaDetail[] {
        var data = JSON.stringify(searchsoadetail)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/loadSOAforAgent', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    downloadPDF(selectedFileForDownload: BeneficiarySoaDetail): Observable<any> {
        console.log('user selected following file for download(network)' + selectedFileForDownload)

        var downloadData = this.http.post<any>('../api/downloadPdf', JSON.stringify(selectedFileForDownload))

        console.log('data reteurned from controller' + downloadData)

        return downloadData
    }

    streamPDF(selectedFileForDownload: BeneficiarySoaDetail): Observable<any> {
        return this.http.post('../api/downloadPdfStream', JSON.stringify(selectedFileForDownload), {
            headers: new HttpHeaders().set('Content-Type', 'application/pdf'),
            responseType: 'blob',
            observe: 'body'
        })
    }

    getSOADataForExport(searchsoadetail: SearchInsertModel): Observable<ExportSOAModel[]> {
        return this.http.post<ExportSOAModel[]>('../api/exportSOAforAgent', JSON.stringify(searchsoadetail))
    }

    getPWSOADataForExport(searchsoadetail: SearchInsertModel): Observable<ExportSOAModel[]> {
        return this.http.post<ExportSOAModel[]>('../api/exportPWSOAforAgent', JSON.stringify(searchsoadetail))
    }
}
